function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenuClosed = function SvgMenuClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width,
    height: props.height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: props.viewBox
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 10h24M8 20h24M8 30h24",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinecap: "round",
    fill: props.color
  }));
};
export default SvgMenuClosed;